export default {
  保存: "Save",
  取消: "Cancel",
  确认: "Confirm",
  删除: "Delete",
  编辑: "Edit",
  新增: "Add",
  搜索: "Search",
  查询: "Search",
  重置: "Reset",
  展开: "Expand",
  收起: "Collapse",
  是: "Yes",
  否: "No",
  操作: "Action",
  查看: "View",
  关闭: "Close",
  暂存: "Save as Draft",
  提交: "Submit",
  点击选择供应商: "Click to Select Supplier",
  点击上传: "Click to Upload",
  文件上传失败: "File upload failed",
};
